import MenuIcon from '@mui/icons-material/Menu';
import { Box, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { makeStyles } from '@material-ui/core/styles';
import { Hidden } from '@mui/material';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BLOG_PATH, CONTACT_PATH, HOME_PATH, PHOTOS_PATH } from '../constants';
import DropdownMenu from './DropdownMenu';
import { TemporaryDrawer } from './TemporaryDrawer';

const useStyles = makeStyles((theme) => ({
    iconButton: {
        [theme.breakpoints.down('md')]: {
            paddingLeft: 0,
        },
    },
}));

export function Navbar() {
    const classes = useStyles();
    const navigate = useNavigate();

    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setDrawerOpen(newOpen);
    };

    return (
        <Box
            sx={{
                position: 'relative',
                zIndex: 10,
                pt: 'calc(env(safe-area-inset-top, 0px) + 9.6px)',
                px: { xs: 1, md: 2 },
                backgroundColor: 'transparent',
            }}
        >
            <Toolbar
                sx={{
                    mx: 'auto',
                    width: '100%',
                    maxWidth: 1200,
                    minHeight: 72,
                    borderRadius: 3,
                    border: 'none',
                    backgroundColor: 'transparent',
                    px: { xs: 1, md: 3 },
                }}
            >
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="home"
                    className={classes.iconButton}
                    onClick={() => navigate(HOME_PATH)}
                    sx={{ borderRadius: 2 }}
                >
                    <Box
                        component="img"
                        src="/logo-blue.png"
                        alt="Website logo"
                        sx={{ height: 42, width: 42, objectFit: 'contain' }}
                    />
                </IconButton>
                <Hidden mdUp>
                    <Button sx={{ color: '#1d4f9e', marginLeft: 'auto' }} onClick={toggleDrawer(true)}>
                        <MenuIcon />
                    </Button>
                    <TemporaryDrawer open={drawerOpen} setOpen={setDrawerOpen} />
                </Hidden>
                <Hidden mdDown>
                    <Link
                        to={HOME_PATH}
                        style={{
                            marginLeft: 'auto',
                            textDecoration: 'none',
                        }}
                    >
                        <Button sx={{ minWidth: 0 }}>
                            <Typography variant="h6" color="#1f4e9c" fontSize={20} fontWeight={600}>
                                Home
                            </Typography>
                        </Button>
                    </Link>
                    <Link to={`/${BLOG_PATH}`} style={{ textDecoration: 'none' }}>
                        <Button
                            sx={{
                                marginLeft: 1.5,
                            }}
                        >
                            <Typography variant="h6" color="#1f4e9c" fontSize={20} fontWeight={600}>
                                Journal
                            </Typography>
                        </Button>
                    </Link>
                    <Link to={`/${PHOTOS_PATH}`} style={{ textDecoration: 'none' }}>
                        <Button
                            sx={{
                                marginLeft: 1.5,
                            }}
                        >
                            <Typography variant="h6" color="#1f4e9c" fontSize={20} fontWeight={600}>
                                Photos
                            </Typography>
                        </Button>
                    </Link>
                    <Box
                        sx={{
                            marginLeft: 1.5,
                        }}
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={(e) => e.preventDefault()}
                    >
                        <DropdownMenu />
                    </Box>
                    <Link to={`/${CONTACT_PATH}`} style={{ textDecoration: 'none' }}>
                        <Button
                            sx={{
                                marginLeft: 1.5,
                            }}
                        >
                            <Typography variant="h6" color="#1f4e9c" fontSize={20} fontWeight={600}>
                                Contact
                            </Typography>
                        </Button>
                    </Link>
                </Hidden>
            </Toolbar>
        </Box>
    );
}
